import React, { useEffect } from 'react';
import { View, Image, ScrollView } from 'react-native';
import InputField from 'src/components/input/input';
import InputHint from 'src/components/input/InputError';
import Button from 'src/components/Button/Button';
import Text from 'src/components/Text/Text';
import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
//import { useGBVariant } from 'src/hooks/useGBVariant';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
//import Loader from 'src/components/loadingTruck/loadingTruck';
import CallBanner from 'src/components/CallBanner/CallBanner';
import styles from './DotNumberScreen.styles';
import { VARIANT_UI } from 'src/features/company/helpers/dotScreenVariants';
import checkIcon from 'src/assets/checkCircle.png';
import { Variant } from '@features/company/types/variant';

interface Props {
  dotNumber: string;
  onChangeDot: (value: string) => void;
  onNext: (variant: Variant) => void;
  onNoDot: () => void;
}

const DotNumberScreen: React.FC<Props> = ({ dotNumber, onChangeDot, onNext, onNoDot }) => {
  const accountType = useSelector((state: RootState) => state.UI.accountType);

  //const { ready, variant } = useGBVariant();
  //console.log('[GB] dot_screen_variant rfrom the hook', variant);

  /*useEffect(() => {
    if (!ready) return;
    console.log('[GB] dot_screen_variant =', variant);
    trackGTMEvent('dot-number-screen-rendered', { dotScreenVariant: variant }, accountType);
  }, [ready, variant]);*/

  useEffect(() => {
    trackGTMEvent('dot-number-screen-rendered', { screenName: 'DotNumberScreen' }, accountType);
  }, []);

  const validateDotNumber = (value: string): string => {
    const cleaned = value.trimStart();
    if (/^\d{0,8}$/.test(cleaned)) {
      return cleaned.replace(/^0+/, '');
    }
    return dotNumber;
  };

  const handleDotChange = (value: string) => {
    onChangeDot(validateDotNumber(value));
  };

  const handleNext = () => {
    //if (!ready) return; // No-op if not ready
    trackGTMEvent('dot-screen-next-button-pressed', { dotScreenVariant: 'v2' }, accountType);
    onNext('v2');
  };

  const handleNoDot = () => {
    trackGTMEvent('dot-screen-no-dot-button-pressed', { dotScreenVariant: 'v2' }, accountType);
    onNoDot();
  };

  /*if (!ready) {
    return <Loader text="Loading experiment..." />;
  }*/

  const ui = VARIANT_UI['v2'];

  return (
    <>
      {/* Call Banner */}
      <CallBanner />
      <ScrollView contentContainerStyle={styles.container}>
        {/* Illustration */}
        <View testID="dot-screen-banner">
          <Image source={ui.image} style={styles.hero} resizeMode="contain" />
        </View>

        {/* Title */}
        <Text variant="h2" style={styles.title} testID="dot-screen-title">
          {ui.title}
        </Text>

        {/* Bullets (only for v1) */}
        {ui.showBullets && (
          <View style={styles.bulletsContainer} testID="dot-screen-bullets">
            {[
              'Hassle‐Free Quotes in Under 5 Minutes',
              'Competitive Rates, Saving You $$$',
              'Dedicated Support from Industry Pros',
            ].map((bulletText) => (
              <View key={bulletText} style={styles.bulletItem}>
                <Image source={checkIcon} style={styles.bulletIcon} />
                <Text variant="title2" style={styles.bulletText}>
                  {bulletText}
                </Text>
              </View>
            ))}
          </View>
        )}

        {/* DOT Input */}
        <View style={styles.fieldContainer}>
          <InputField
            testID={'enter-your-dot-number'}
            variant="caption"
            label="DOT"
            placeholder="Please enter your DOT number"
            value={dotNumber}
            onChange={handleDotChange}
          />
          <InputHint hintText="Users who enter their DOT save 23% on average" />
        </View>

        {/* Or Divider */}
        <Text variant="body1" style={styles.orText}>
          Or
        </Text>

        <Button
          testID={'i-dont-have-dot-btn'}
          title="I don't have a DOT yet"
          type="tertiary"
          colorVariant="default"
          onPress={handleNoDot}
          style={styles.nextButton}
        />

        {/* CTA Button */}
        <View style={styles.actions} testID="dot-screen-next-button">
          <Button
            testID={'show-me-my-savings'}
            title={ui.button}
            type="primary"
            colorVariant={dotNumber.length === 0 ? 'disabled' : 'default'}
            onPress={handleNext}
            disabled={!dotNumber || dotNumber.length === 0}
            style={styles.nextButton}
          />
        </View>
      </ScrollView>
    </>
  );
};

export default DotNumberScreen;
